import { getCloudinaryUrl } from "../common/common.utils";

export function cloudinaryUrl() {
    return {
        restrict: "A",
        scope: {
            publicId: "<",
        },
        link: function (scope, element, attrs) {
            attrs.$set("href", getCloudinaryUrl(scope.publicId));
        },
    };
}
